export default __webpack_public_path__ + "static/yolo-glacier-be1a3e57ac005cb00c16d590b4746d10.jpg";